import { __assign, __rest } from "tslib";
import { pickBy, identity, omit } from 'lodash';
import { isSSR } from 'wix-rich-content-common';
function paramsToBiFields(essentials) {
    var bsi = essentials.bsi, msid = essentials.metaSiteId, _visitorId = essentials.visitorId, _appId = essentials.appId, _instanceId = essentials.instanceId, _siteOwnerId = essentials.siteOwnerId;
    return pickBy({ bsi: bsi, msid: msid, _visitorId: _visitorId, _appId: _appId, _instanceId: _instanceId, _siteOwnerId: _siteOwnerId }, identity);
}
var RicosBILogger = /** @class */ (function () {
    function RicosBILogger(_a) {
        var logger = _a.logger, webBiLogger = _a.webBiLogger, genericParams = _a.genericParams, _b = _a.essentials, essentials = _b === void 0 ? {} : _b;
        var biLoggerPromise;
        if (!isSSR()) {
            biLoggerPromise = Promise.resolve(webBiLogger || import('@wix/web-bi-logger'));
        }
        this.logger =
            biLoggerPromise &&
                biLoggerPromise.then(function (biLogger) {
                    return biLogger
                        .factory()
                        .updateDefaults(__assign(__assign({}, genericParams), paramsToBiFields(essentials)))
                        .logger();
                });
        this.newLogger = logger;
        // msid exists already in the new logger (consumer's logger)
        this.genericParams = omit(genericParams, 'msid');
    }
    RicosBILogger.prototype.log = function (func, params) {
        var _a, _b;
        if (this.newLogger) {
            var logObject = func(params);
            var eventParams = logObject.params, rest = __rest(logObject, ["params"]);
            (_b = (_a = this.newLogger).report) === null || _b === void 0 ? void 0 : _b.call(_a, __assign({ params: __assign(__assign({}, this.genericParams), eventParams) }, rest));
        }
        else if (this.logger) {
            this.logger.then(function (logger) { return logger.report(func(params)); });
        }
        else {
            console.error("[RicosBILogger.ts:log] RicosBILogger was not initialized");
        }
    };
    return RicosBILogger;
}());
export { RicosBILogger };
//# sourceMappingURL=RicosBILogger.js.map